import axios from 'axios'
import * as tool from '../libs/tool'

export default class Fetch {
  constructor (baseUrl, appId) {
    this.appId = appId || tool.getAppId() || null
    this.BASE_URL = baseUrl
    this.timeout = 60 * 1000
  }

  setInterceptors = (instance) => {
    instance.interceptors.request.use(config => {
      if (config.method === 'get') {
        config.params = {
          ...config.params,
          appId: this.appId || tool.getAppId()
        }
      }
      if (config.method === 'post') {
        config.data = {
          ...config.params,
          appId: this.appId || tool.getAppId()
        }
      }
      return config
    }, err => Promise.reject(err))

    instance.interceptors.response.use(response => {
      return response.data
    }, err => Promise.reject(err))
  }

  request (method, url, params, data) {
    const instance = axios.create()
    const config = {
      method,
      url,
      params,
      data,
      baseURL: this.BASE_URL,
      timeout: this.timeout
    }
    this.setInterceptors(instance)
    return instance(config)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js